import React, { useState } from "react";
import { format, parse, startOfDay } from "date-fns";
import { fr } from "date-fns/locale";
import { CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";

/**
 * DatePicker — calendrier visuel localisé FR.
 * @param value string "YYYY-MM-DD" or ""
 * @param onChange (iso) => void  (iso au format "YYYY-MM-DD")
 * @param testId data-testid sur le bouton
 * @param disablePast bool (default true) — désactive les jours avant aujourd'hui
 * @param placeholder string
 */
export default function DatePicker({
  value,
  onChange,
  testId,
  disablePast = true,
  placeholder = "Sélectionner...",
  className = "",
}) {
  const [open, setOpen] = useState(false);

  const selectedDate = value
    ? parse(value, "yyyy-MM-dd", new Date())
    : undefined;

  const handleSelect = (date) => {
    if (!date) return;
    onChange(format(date, "yyyy-MM-dd"));
    setOpen(false);
  };

  const today = startOfDay(new Date());

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          data-testid={testId}
          type="button"
          variant="outline"
          className={`w-full justify-start text-left font-normal border-white/10 bg-white/[0.08] text-slate-50 hover:bg-white/[0.12] hover:text-white ${className}`}
        >
          <CalendarIcon className="mr-2 h-4 w-4 text-slate-400" />
          {selectedDate ? (
            <span>{format(selectedDate, "dd/MM/yyyy")}</span>
          ) : (
            <span className="text-slate-400">{placeholder}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto p-0 border-white/10 bg-[#0f1320] text-slate-100"
        align="start"
      >
        <Calendar
          mode="single"
          selected={selectedDate}
          onSelect={handleSelect}
          locale={fr}
          disabled={disablePast ? { before: today } : undefined}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
